import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Bonuses } from './components/Bonuses';
import { TargetAudience } from './components/TargetAudience';
import { HowItWorks } from './components/HowItWorks';
import { FAQ } from './components/FAQ';
import { Pricing } from './components/Pricing';
export function App() {
  useEffect(() => {
    // Meta Pixel
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1293149622738671');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1293149622738671&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return <div className="min-h-screen bg-brand-dark text-slate-200 font-sans selection:bg-brand-gold/30 selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Problem data-id="element-3" />
        <Solution data-id="element-4" />
        <Bonuses data-id="element-5" />
        <TargetAudience data-id="element-6" />
        <HowItWorks data-id="element-7" />
        <FAQ data-id="element-8" />
        <Pricing data-id="element-9" />
      </main>

      <footer className="bg-brand-darker py-8 border-t border-slate-800 text-center text-slate-500 text-sm" data-id="element-10">
        <div className="max-w-6xl mx-auto px-6" data-id="element-11">
          <p data-id="element-12">
            © {new Date().getFullYear()} Networker Magnético. Todos los
            derechos reservados.
          </p>
          <p className="mt-2 text-xs opacity-60 max-w-2xl mx-auto" data-id="element-13">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}